export default {
  id: 180,
  title: 'Target #180 - Kuwait',
  url: 'https://cssbattle.dev/play/180',
  colors: ['#000000', '#13AA4B', '#FFFFFF', '#EC1E25'],
  solution:
    '<style>body{margin:0;border-style:solid;border-width:100px 0 100px 120px;border-color:#13AA4B #000 #EC1E25',
}
